import Api, {
  baseURL,
  requestOptionsDELETE,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsPUT,
  requestOptionsPUTWithBody
} from '../api';
import newFetch from '../utils/newFetch';
import removeCaracters from '../utils/removeCaracters';

const state = {
  transhipments: [],
  negotiations: [],
  negotiationsCity: [],
  negotiationsCNPJ: [],
  stopsTransfer: [],
  transhipmentByCity: [],
  transhipmentSelectedName: '',
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  paginateCity: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  paginateCNPJ: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  paginateTransfer: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  filters: {
    nfeNumber: null
  }
};

const getters = {
  getTranshipments: (state) => state.transhipments,
  getNegotiations: (state) => state.negotiations,
  getNegotiationsCity: (state) => state.negotiationsCity,
  getNegotiationsCNPJ: (state) => state.negotiationsCNPJ,
  getStopsTransfer: (state) => state.stopsTransfer,
  getPaginate: ({ paginate }) => {
    return `?PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}`;
  },
  getPaginateCity: ({ paginateCity }) => {
    return `?PageSize=${paginateCity.pageSize}&PageNumber=${paginateCity.pageNumber}`;
  },
  getPaginateCNPJ: ({ paginateCNPJ }) => {
    return `?PageSize=${paginateCNPJ.pageSize}&PageNumber=${paginateCNPJ.pageNumber}`;
  },
  getPaginateTransfer: ({ paginateTransfer }) => {
    return `?PageSize=${paginateTransfer.pageSize}&PageNumber=${paginateTransfer.pageNumber}`;
  },
  getFilters: ({ filters }) => {
    return filters.nfeNumber ? '&NumberNfe=' + filters.nfeNumber : '';
  }
};

const mutations = {
  setTranshipmentSelectedName(state, payload) {
    state.transhipmentSelectedName = payload;
  },
  setTranshipments(state, payload) {
    state.transhipments = payload;
  },
  setNegotiations(state, payload) {
    state.negotiations = payload;
  },
  setNegotiationsCity(state, payload) {
    state.negotiationsCity = payload;
  },
  setNegotiationsCNPJ(state, payload) {
    state.negotiationsCNPJ = payload;
  },
  setStopsTransfer(state, payload) {
    state.stopsTransfer = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  setPageNumberCity(state, payload) {
    state.paginateCity.pageNumber = payload;
  },
  setTotalPagesCity(state, payload) {
    state.paginateCity.totalPages = payload;
  },
  setTotalRecordsCity(state, payload) {
    state.paginateCity.totalRecords = payload;
  },
  setPageNumberCNPJ(state, payload) {
    state.paginateCNPJ.pageNumber = payload;
  },
  setTotalPagesCNPJ(state, payload) {
    state.paginateCNPJ.totalPages = payload;
  },
  setTotalRecordsCNPJ(state, payload) {
    state.paginateCNPJ.totalRecords = payload;
  },
  setPageNumberTransfer(state, payload) {
    state.paginateTransfer.pageNumber = payload;
  },
  setTotalPagesTransfer(state, payload) {
    state.paginateTransfer.totalPages = payload;
  },
  setTotalRecordsTransfer(state, payload) {
    state.paginateTransfer.totalRecords = payload;
  },
  toggleDisableTranshipment(state, payload) {
    state.transhipments[payload.index].disabled = !payload.disabled;
  },
  trashTranshipment(state, payload) {
    state.transhipments = state.transhipments.filter(({ id }) => id !== payload);
  },
  setFiltersNfeNumberId(state, payload) {
    state.filters.nfeNumber = payload;
  },
  setTranshipmentByCityid(state, payload) {
    state.transhipmentByCity = payload;
  }
};

const actions = {
  fetchNegotiations(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.negotiations + context.getters.getPaginate,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setNegotiations', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipment(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipment + context.getters.getPaginate,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setTranshipments', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentCities() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getTranshipmentsCities, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({data}) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentByCity(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getTranshipmentByCity + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setTranshipmentByCityid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getSummaryDataTranshipment() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getSummaryDataTranshipment, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  fetchAllTranshipment(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipment + `?PageSize=1000000&PageNumber=1`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          context.commit('setTranshipments', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentByID(context, param) {
    const isCompany = param.type;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (isCompany ? Api.createTranshipment : Api.createTranshipmentPersonal) + param.id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchNegotiationWeigthByID(context, body = {}) {
    const { isCnpj } = body;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          (isCnpj ? Api.transhipmentNegotiationsCpfOrCnpjWeightDelivery : Api.transhipmentNegotiationsWeightDelivery) +
          body.id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editNegotiationWeigthByID(context, params) {
    const { isCnpj } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          (isCnpj ? Api.transhipmentNegotiationsCpfOrCnpjWeightDelivery : Api.transhipmentNegotiationsWeightDelivery),
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), params)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchNegotiationByID(context, params) {
    const { id, isCnpj } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (isCnpj ? Api.transhipmentNegotiationsCNPJByID : Api.transhipmentNegotiationsCityByID) + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentNegotiationCityByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transhipmentNegotiationsCityByID + context.getters.getPaginateCity + `&TranshipmentId=${id}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setNegotiationsCity', data);

          context.commit('setTotalPagesCity', totalPages);
          context.commit('setTotalRecordsCity', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentNegotiationCNPJByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transhipmentNegotiationsCNPJByID + context.getters.getPaginateCNPJ + `&TranshipmentId=${id}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setNegotiationsCNPJ', data);

          context.commit('setTotalPagesCNPJ', totalPages);
          context.commit('setTotalRecordsCNPJ', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentBetweenDeliverers(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipmentBetweenDeliverers + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentBetweenStops(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentBetweenStops +
          context.getters.getPaginateTransfer +
          `&TranshipmentId=${id}` +
          context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setStopsTransfer', data);

          context.commit('setTotalPagesTransfer', totalPages);
          context.commit('setTotalRecordsTransfer', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentBetweenDeliveriesPending(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getDeliveriesPending + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipmentBetweenNfes(context, params) {
    const { id, statusesIds } = params;
    console.log(statusesIds);
    let statusesParam = statusesIds.reduce((acc, cur, i) => {
      const concatSign = statusesIds.length - 1 === i ? '' : '&';
      return (acc += `statusId=${cur}${concatSign}`);
    }, '');

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManegementShipmentsNFE + id + `?${statusesParam}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createTranshipment(_, body = {}) {
    const isCompany = body.type !== 'personal';
    const isDeliverierTranshipment = body.params.isDeliverierTranshipment;

    let newBody = {
      [isCompany ? 'companyName' : 'name']: body.params.name,
      email: body.params.email || null,
      password: body.params.password,
      confirmPassword: body.params.confirmPassword,
      phones: [removeCaracters(body.params.phone), removeCaracters(body.params.cellphone)],
      address: body.params.addressData,
      bankData: {
        ...body.params.bankData,
        cpfOrCnpjHolder: removeCaracters(body.params.bankData.cpfOrCnpjHolder)
      },
      isDeliverierTranshipment: body.params.isDeliverierTranshipment
    };

    if (isCompany) {
      newBody.cnpj = body.params.cnpj;
      newBody.tradingName = body.params.tradingName;
    } else {
      newBody.cpf = body.params.cpf;
    }

    if (isDeliverierTranshipment) {
      newBody.cnhNumber = removeCaracters(body.params.cnhNumber);
      newBody.vehicle = body.params.vehicleData;
      if (isCompany) {
        newBody.cpfDeliverierTranshipment = removeCaracters(body.params.cpfDeliverierTranshipment);
      }
    }

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (isCompany ? Api.createTranshipment : Api.createTranshipmentPersonal),
        requestOptionsPOST(localStorage.getItem('accessToken'), newBody)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editTranshipment(_, body) {
    const isCompany = body.type !== 'personal';
    const isDeliverierTranshipment = body.params.isDeliverierTranshipment;

    let newBody = {
      id: body.params.id,
      [isCompany ? 'companyName' : 'name']: body.params.name,
      email: body.params.email || null,
      password: body.params.password || null,
      confirmPassword: body.params.confirmPassword || null,
      phones: [removeCaracters(body.params.phone), removeCaracters(body.params.cellphone)],
      address: body.params.addressData,
      bankData: {
        ...body.params.bankData,
        cpfOrCnpjHolder: removeCaracters(body.params.bankData.cpfOrCnpjHolder)
      },
      isDeliverierTranshipment: body.params.isDeliverierTranshipment
    };

    if (isCompany) {
      newBody.cnpj = body.params.cnpj;
      newBody.tradingName = body.params.tradingName;
    } else {
      newBody.cpf = body.params.cpf;
    }

    if (isDeliverierTranshipment) {
      newBody.cnhNumber = removeCaracters(body.params.cnhNumber);
      newBody.vehicle = body.params.vehicleData;
      if (isCompany) {
        newBody.cpfDeliverierTranshipment = removeCaracters(body.params.cpfDeliverierTranshipment);
      }
    }

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (isCompany ? Api.createTranshipment : Api.createTranshipmentPersonal),
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), newBody)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteTranshipment(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteTranshipment + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  toggleTranshipment(_, item) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (!item.disabled ? Api.disableTranshipment : Api.enableTranshipment) + item.id,
        requestOptionsPUT(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createNegotiationCity(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transhipmentNegotiationsCityByID,
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createNegotiationCNPJ(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transhipmentNegotiationsCNPJByID,
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editNegotiationCity(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transhipmentNegotiationsCityByID,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  setTransferDataDeliverers(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transferDataDeliverers,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  setTransferDataStops(_, { body, recalculateValue }) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + `${Api.transferStops}?recalculateValue=${recalculateValue}`,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), { ...body })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editNegotiationCNPJ(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transhipmentNegotiationsCNPJByID,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createNegotiationWeight(_, body = {}) {
    const isCity = !!body.negotiationCityId;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          (isCity ? Api.transhipmentNegotiationsWeightDelivery : Api.transhipmentNegotiationsCpfOrCnpjWeightDelivery),
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteNegotiationCity(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transhipmentNegotiationsCityByID + id,
        requestOptionsDELETE(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteNegotiationCityWeight(_, body = {}) {
    const isCity = !!body.negotiationCityId;
    return new Promise((resolve, reject) => {
      newFetch(
        isCity
          ? baseURL + Api.transhipmentNegotiationsWeightDelivery + body.id
          : baseURL + Api.transhipmentNegotiationsCpfOrCnpjWeightDelivery + body.id,
        requestOptionsDELETE(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteNegotiationCNPJ(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transhipmentNegotiationsCNPJByID + id,
        requestOptionsDELETE(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getTranshipmentsDashboardData(_, params) {
    const { startDate, endDate } = params;
    const hasFilters = startDate !== '';
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentsDashboardData +
          (hasFilters ? `?AuthorizationDateStart=${startDate}&AuthorizationDateEnd=${endDate}` : ''),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },

  getTranshipmentsDashboardDataByTranshipmentId(_, params) {
    const { startDate, endDate, transhipmentId } = params;
    const hasFilters = startDate !== '';
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentsDashboardDataByTranshipmentId +
          `?transhipmentId=${transhipmentId}` +
          (hasFilters ? `&AuthorizationDateStart=${startDate}&AuthorizationDateEnd=${endDate}` : ''),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },

  getTranshipmentsDashboardQuantityDataByTranshipmentId(_, params) {
    const { startDate, endDate, transhipmentId, type } = params;
    const hasFilters = startDate !== '';
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentQuantityByTranshipmentId +
          `?transhipmentId=${transhipmentId}&type=${type}` +
          (hasFilters ? `&AuthorizationDateStart=${startDate}&AuthorizationDateEnd=${endDate}` : ''),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsDashboardQuantityData(_, params) {
    const { startDate, endDate, type } = params;
    const hasFilters = startDate !== '';
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentsQuantity +
          `?type=${type}` +
          (hasFilters ? `&AuthorizationDateStart=${startDate}&AuthorizationDateEnd=${endDate}` : ''),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentFinancialQuantityByTranshipmentId(_, params) {
    const { startDate, endDate, transhipmentId } = params;
    const hasFilters = startDate !== '';
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentFinancialQuantityByTranshipmentId +
          `?transhipmentId=${transhipmentId}` +
          (hasFilters ? `&AuthorizationDateStart=${startDate}&AuthorizationDateEnd=${endDate}` : ''),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsFinancialQuantity(_, params) {
    const { startDate, endDate } = params;
    const hasFilters = startDate !== '';
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentFinancialDataForAllTransshipments +
          (hasFilters ? `?AuthorizationDateStart=${startDate}&AuthorizationDateEnd=${endDate}` : ''),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsEvaluationsByTranshipmentId(_, params) {
    const { transhipmentId, pageSize, pageNumber } = params;
    // const hasFilters = startDate !== '';
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentEvaluationByTranshipmentId +
          `?transhipmentId=${transhipmentId}&PageSize=${pageSize}&PageNumber=${pageNumber}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },

  saveTranshipmentEvaluation(_, params) {
    const { transhipmentId, evaluation } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.saveTranshipmentEvaluation,
        requestOptionsPOST(localStorage.getItem('accessToken'), { transhipmentId, evaluation })
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },

  getManageTranshipmentDeliverer(_, params) {
    const { id } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManageTranshipmentDeliverers + `/${id}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsWithoutNegotiation() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getTranshipmentsWithoutNegotiation, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },

  getNegotiation(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.negotiations + `/${id}`, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  createNegotiation(_, params) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.negotiations, requestOptionsPOST(localStorage.getItem('accessToken'), params))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  editNegotiation(_, params) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.negotiations, requestOptionsPUTWithBody(localStorage.getItem('accessToken'), params))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  deleteNegotiation(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.negotiations + `/${id}`, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  getNegotiationTypes() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getNegotiationTypes, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  },
  getNegotiationSubTypes() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getSubTypeNegotiations, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
